module.exports = __webpack_public_path__ + "img/puzzle_11.5db5d39b.png";